import React from "react";
import OfferTicket from "../Ticket";
import RewardTicket from "../RewardTicket";
import { useCoupons, useRewards } from "hooks/api/useRefer";
import { Skeleton } from "antd";

const TICKET_COLORS = [
  { bg: "#36D9CB", text: "#039387" },
  { bg: "#9C9CF4", text: "#5D5DAB" },
  { bg: "#F49C9C", text: "#AB5D5D" },
];

function Footer() {
  const { data: couponResponse, isLoading: couponsLoading } = useCoupons();
  const { data: rewardsResponse, isLoading: rewardsLoading } = useRewards();

  const coupons = couponResponse?.data?.coupon_data || [];
  const rewards = rewardsResponse?.data?.rewards || [];

  if (couponsLoading || rewardsLoading) {
    return (
      <div className="flex flex-col gap-3">
        <Skeleton active paragraph={{ rows: 4 }} />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Coupons Section */}
      {coupons.length > 0 && (
        <div className="flex flex-col gap-3">
          <span className="font-title-normal leading-5 text-black">
            Coupons
          </span>
          <div className="flex flex-col gap-2">
            {coupons.map((item, i) => {
              const color = TICKET_COLORS[i % TICKET_COLORS.length];
              return (
                <OfferTicket
                  key={item.coupon_code}
                  data={{
                    offer: item.discount_text,
                    title: item.coupon_name || "Exclusive Reward",
                    code: item.coupon_code,
                    valid: item.date_to,
                    bg: color.bg,
                    text: color.text,
                  }}
                />
              );
            })}
          </div>
        </div>
      )}

      {/* Rewards Section */}
      {rewards.length > 0 && (
        <div className="flex flex-col gap-3">
          <span className="font-title-normal leading-5 text-black">
            Rewards
          </span>
          <div className="flex flex-col gap-2">
            {rewards.map((item, i) => {
              const color = TICKET_COLORS[(i + 1) % TICKET_COLORS.length];
              return (
                <RewardTicket
                  key={item.aec_id}
                  data={{
                    username: item.username,
                    aec_id: item.aec_id,
                    reward_type: "REWARD",
                    days: item.days,
                    contact: item.contacts,
                    bg: color.bg,
                    text: color.text,
                  }}
                />
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default Footer;
